export const init = () => {
  const the3dTourLinks = document.querySelectorAll('.js-3d-tour-link');

  let observer = null;
  if (IntersectionObserver) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const href = entry.target.dataset.href;
          const section = entry.target.dataset.section ? entry.target.dataset.section : 'room_page_photos';

          App.track.event('room_page_interaction', {
            section,
            element: 'explore_3d_tour',
            element_value: href,
            interaction: 'visible',
          });
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    });
  }

  the3dTourLinks.forEach(link => {
    if (observer) {
      observer.observe(link);
    }

    link.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();

      const href = e.currentTarget.dataset.href;
      const section = e.currentTarget.dataset.section ? e.currentTarget.dataset.section : 'room_page_photos';

      App.track.event('room_page_interaction', {
        section,
        element: 'explore_3d_tour',
        element_value: href,
        interaction: 'click',
      });

      window.open(href, '_blank');
    });
  });
};
